import { $t } from '@/locales'
function padLeftZero(str) {
  return `00${str}`.substr(str.length)
}

function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    // eslint-disable-next-line no-param-reassign
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`
      // eslint-disable-next-line no-param-reassign
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }

  return fmt
}

export function formatUtc(utcTime, accuracy) {
  if (accuracy === 'day') {
    if (utcTime) {
      return formatDate(new Date(utcTime), 'yyyy-MM-dd hh:mm:ss').split(' ')[0]
    }

    return ''
  } else if (accuracy === 'hour') {
    if (utcTime) {
      return formatDate(new Date(utcTime), 'yyyy-MM-dd hh:mm:ss').split(' ')[1]
    }

    return formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss').split(' ')[1]
  }
  if (utcTime) {
    return formatDate(new Date(utcTime), 'yyyy-MM-dd hh:mm:ss')
  }

  return formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
}

export function fomatType(value, type) {
  if (type === 'storeType') {
    if (value === 1) {
      return $t('新签')
    } else if (value === 2) {
      return $t('续签')
    }

    return value
  }
  if (type === 'initiatorDeptName' && value) {
    return value.substr(0, 15)
  }

  return value
}

export function formatName(value) {
  if (!value) return
  const maxLength = 10
  if (value.length < maxLength) return value

  return `${value.slice(0, maxLength)}...`
}
